import * as React from 'react';

import { Container, Content } from '../SharedDocuments/styles';
import { SelectedNote } from '../../../containers/Share/reducer';

interface SharedNotesProps {
	selectedNotes: SelectedNote[];
}

const SharedNotes = ({ selectedNotes }: SharedNotesProps) => (
	<Container>
		{selectedNotes.map(({ id, title }) => (
			<Content key={id}>
				{title}
			</Content>
		))}
	</Container>
);

export default SharedNotes;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Share/SharedNotes/index.tsx